import { useActionData } from 'react-router'

import { AppActionData } from '~/portal/root.action.ts'
import { LandingPagePreviewActionData } from '~/portal/types/preview'

export const usePreviewData = (): LandingPagePreviewActionData => {
  const { previewData, isPreview = false } = useActionData<AppActionData>() || {}

  return ({ previewData, isPreview })
}